<template lang="pug">
    v-data-table.elevation-1(:headers='headers'  :items='prods')
      template(v-slot:item.despachada='props')
        v-text-field(v-model.number='props.item.despachada' @input='changeDespachada(props.item)' type="number", min="0", label='Cant. Despachada', single-line)

      template(v-slot:item.precioBs='props')
        v-edit-dialog(:return-value.sync='props.item.precioBs', large='', persistent='', @save='updatePrecio(props.item)', @cancel='cancel', @open='open', @close='close')
          div {{ props.item.precioBs }}
          template(v-slot:input)
            v-text-field(v-model='props.item.precioBs', type="number", min="0", label='Editar', single-line='', counter='', autofocus='')

      template(v-slot:item.porcDescuento='props')
        v-text-field(v-model.number='props.item.porcDescuento' @input='changeDescuento(props.item)' type="number", min="0", label='% Descuento', single-line)

      v-snackbar(v-model='snack', :timeout='3000', :color='snackColor')
        | {{ snackText }}
        v-btn(text='', @click='snack = false') Cerrar

      template(v-slot:top)
        v-toolbar(flat color='primary' dark)
          v-toolbar-title.justify-center(color='success') Agregar
          v-divider.mx-4(inset vertical)
          v-spacer
          v-btn.mx-2(color='success' dark @click='agregarTodos') Validar cantidades
          v-dialog(v-model='dialog' persistent scrollable max-width='40%')
            template(v-if=" p === 'activar' " v-slot:activator='{ on }')
              v-btn.mx-2(color='success' dark v-on='on') Agregar Producto
            v-card
              v-card-title
                span.headline {{ formTitle }}
              v-card-text
                v-container
                  v-row
                    v-col(cols='12' sm='12' md='12' v-if="editedIndex === -1")
                      v-autocomplete(id='auto-hijopedido-producto'  dense outlined v-model='editedItem.idProducto' :items='idProductosArray' @change='cambiarProducto' label='Producto')
                    v-col(cols='12' sm='12' md='12' v-else)
                      v-text-field(id='auto-hijopedido-producto'  dense outlined v-model='editedItem.idProducto' label='Producto')
                  v-row
                    v-col(cols='12' sm='12' md='12')
                      v-text-field(dense outlined type='number' v-model='editedItem.despachada' label='Cant. a facturar')
                  //- v-row
                  //-   v-col(cols='6' sm='6' md='6')
                  //-     v-text-field(dense outlined readonly :value='editedItem.precioBs | read'   label='Precio')
                  //-   v-col(cols='6' sm='6' md='6')
                  //-     v-text-field(dense outlined v-model='editedItem.idIva.descripcion' readonly label='IVA (%)')
                  //- v-row
                  //-   v-col(cols='6' sm='6' md='6')
                  //-     v-text-field(dense outlined :value='editedItem.gravado | read'  readonly label='Gravado')
                  //-   v-col(cols='6' sm='6' md='6')
                  //-     v-text-field(dense outlined :value='editedItem.exento | read' readonly label='exento')
                  v-row(v-if='!$store.state.config.descuentoVenta.valor')
                    v-col(cols='12' sm='12' md='12')
                      v-text-field(dense outlined v-model='editedItem.porcDescuento' min='0' type='number' label='% Descuento')
                    //- v-col(cols='6' sm='6' md='6')
                    //-   v-text-field(dense outlined :value='editedItem.subTotal | read'  readonly label='subTotal')
                  v-row
                    v-col(cols='12' sm='12' md='12')
                      v-text-field(dense outlined :value='editedItem.total | read'  readonly label='Total + IVA')
              v-card-actions
                v-spacer
                v-btn(color='error' small dark @click.native='close')
                  v-icon mdi-close
                  | Cancelar
                v-btn(color='success' small dark @click.native='save')
                  v-icon mdi-content-save
                  | Guardar
      //- template(v-if=" p === 'activar' " v-slot:item.action='{ item }')
      //-   v-icon.mr-2(color='warning' @click='editItem(item)') mdi-pencil
      //-   v-icon(color='red' @click='deleteItem(item)') mdi-delete
</template>

<script>
import Api from '@/services/methods'
import { EventBus } from '../Events'
export default {
  props: ['prods', 'p', 'facturar'], // se lee como value
  data: () => ({
    snack: false,
    snackColor: '',
    snackText: '',
    dialog: false,
    headers: [],
    headers0: [
      { text: 'Codigo', value: 'idProducto.nombre' },
      { text: 'Nombre', value: 'idProducto.descripcion' },
      { text: 'Stock', value: 'stock' },
      { text: 'Cant. Solicitada ', value: 'cantidadSolicitada' },
      { text: 'Cant. por Facturar ', value: 'cantidadActual' },
      { text: 'Cant. a Facturar', value: 'despachada' },
      { text: 'Porc. Descuento', value: 'porcDescuento' },
      { text: 'Precio(Bs)', value: 'precioBs'},
      { text: 'Precio($)', value: 'precio'},
      { text: 'Sub Total', value: 'subTotal' },
      { text: 'Monto Total', value: 'total' }
      // { text: "Acciones", value: "action", align: "right", sortable: false }
    ],
    headers1: [
      { text: 'Producto', value: 'idProducto.nombre' },
      { text: 'Stock', value: 'stock' },
      { text: 'Cant. Solicitada ', value: 'cantidadSolicitada' },
      { text: 'Cant. por Facturar ', value: 'cantidadActual' },
      { text: 'Cant. a Facturar', value: 'despachada' },
      { text: 'Precio(Bs)', value: 'precioBs'},
      { text: 'Precio($)', value: 'precio'},
      { text: 'Sub Total', value: 'subTotal' },
      { text: 'Monto Total', value: 'total' }
      // { text: "Acciones", value: "action", align: "right", sortable: false }
    ],
    productos: [],
    idProductosArray: [],
    iva: [],
    idIVAArray: [],
    valorIva: 0,
    cxc: [],
    precioDescuento: 0,
    editedIndex: -1,
    editedItem: {
      idProducto: '',
      cantidadActual: 0,
      precioBs: 0,
      idIva: '',
      subTotal: 0,
      gravado: 0,
      exento: 0,
      total: 0,
      baseImponible: 0,
      porcDescuento: 0,
      despachada: 0,
      stock: 0
    },
    defaultItem: {
      idProducto: '',
      cantidadActual: 0,
      precioBs: 0,
      idIva: '',
      subTotal: 0,
      gravado: 0,
      exento: 0,
      total: 0,
      baseImponible: 0,
      porcDescuento: 0,
      despachada: 0,
      stock: 0
    }
  }),

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'Cargar producto' : 'Editar Producto'
    }
  },

  watch: {
    dialog (val) {
      val || this.close()
    },

    'editedItem.despachada': function (val) {
      if (parseInt(val) > 0) {
        this.editedItem.subTotal = parseInt(val) * this.editedItem.precioBs
        this.precioDescuento = this.editedItem.subTotal
        this.actualizarPrecios(this.editedItem)
      }
    },

    'editedItem.porcDescuento': function (val) {
      if (parseInt(val) >= 0) {
        this.editedItem.subTotal = (1 - parseInt(val) / 100) * this.precioDescuento
        this.actualizarPrecios(this.editedItem)
      } else if (!parseInt(val)) {
        this.editedItem.porcDescuento = 0
        this.editedItem.subTotal = this.precioDescuento
      }
    }
  },

  created () {
    this.initialize()
  },

  methods: {
    initialize () {
      this.listarAlmacenes()
      this.configHeaders()
    },

    configHeaders () {
      if (this.$store.state.config.descuentoVenta.valor) this.headers =  [...this.headers1]
      else this.headers = [...this.headers0]
    },

    actualizarPrecios (val) {
      if (val.idIva.valor > 0) {
        // producto con idIva
        console.log(val.idIva, Math.round(val.subTotal * val.idIva.valor * 100) / 100)
        val.gravado = Math.round(val.subTotal * val.idIva.valor * 100) / 100
        val.exento = 0
        val.total = Math.round((val.gravado + val.subTotal) * 100) / 100
        val.baseImponible = val.subTotal
      } else {
        // producto sin idIva
        val.gravado = 0
        val.exento = val.subTotal
        val.total = val.exento
        val.baseImponible = 0
      }
      // this.redondeo();
    },

    listarAlmacenes () {
      Api.get('proalma/soloVenta')
        .then(response => {
          console.log(response.data)
          this.productos = response.data
          response.data.map(data => {
            this.idProductosArray.push({
              text: `${data.idProducto.nombre} - ${data.idProducto.descripcion}`,
              value: data.idProducto._id,
              nombre: data.idProducto.nombre, 
              descripcion: data.idProducto.descripcion, 
              unidadMedida: data.idProducto.unidadMedida,
              cantidad: data.cantidad
            })
          })
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar',
             // text: 'Por favor, verifique los datos e intente de nuevo'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message);
          }
        })
    },

    cambiarProducto (data) {
      let proAlma = this.productos.find(
        proAlma => proAlma.idProducto._id === data
      )
      this.editedItem.precioBs = proAlma.precioBs
      this.editedItem.idIva = proAlma.idIva
      this.precioDescuento = 0
      if (this.editedItem.cantidadActual > 0) {
        this.actualizarPrecios(this.editedItem)
      }
    },

    redondeo () {
      this.editedItem.subTotal = Number.parseFloat(
        this.editedItem.subTotal
      ).toFixed(2)
      this.editedItem.total = Number.parseFloat(this.editedItem.total).toFixed(
        2
      )
      this.editedItem.gravado = Number.parseFloat(
        this.editedItem.gravado
      ).toFixed(2)
      this.editedItem.exento = Number.parseFloat(
        this.editedItem.exento
      ).toFixed(2)
    },

    formato (fecha) {
      return fecha.substr(0, 10)
    },

    updatePrecio (item) {
      if (item.subTotal > 0) {
        item.subTotal = Math.round(parseInt(item.despachada) * item.precioBs * 100) / 100
        this.actualizarPrecios(item)
        this.$emit('actualizar')
      }
    },

    validarCampos () {
      if (true) {
        this.$swal({
          icon: 'error',
          title: 'Formulario incompleto',
          text: 'Por favor llene todos los campos para continuar'
        })
        return true
      }
      return false
    },

    editItem (item) {
      this.editedIndex = this.value.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
      this.cambiarProducto(this.editedItem.idProducto._id)
    },

    deleteItem (item) {
      const index = this.value.indexOf(item)
      this.$swal({
        icon: 'warning',
        title: '¿Seguro que quieres borrar?',
        text: 'No podras revertir esto',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, borrar',
        cancelButtonText: 'cancelar'
      }).then(result => {
        if (result.value) {
          this.$swal('Borrado!', 'Su registro fue borrado.', 'success')
          this.value.splice(index, 1)
        }
      })
    },

    cancel () {
      this.snack = true
      this.snackColor = 'error'
      this.snackText = 'Cancelado'
    },
    open () {
      this.snack = true
      this.snackColor = 'info'
      this.snackText = 'Editor abierto'
    },

    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    agregarTodos () {
      this.prods.map(prod => {
        if (prod.stock > prod.cantidadActual) {
          prod.despachada = prod.cantidadActual
        }
        else {
          prod.despachada = prod.stock
        }
        prod.subTotal = Math.round(parseInt(prod.despachada) * prod.precioBs * 100) / 100
        this.actualizarPrecios(prod)
      })
      this.$emit('actualizar')
    },

    changeDespachada (val) {
      if (val.despachada !== '' || val.despachada > 0) {
        if (val.porcDescuento > 0) {
          const porc = (parseInt(val.porcDescuento) / 100)
          val.subTotal = Math.round(parseInt(val.despachada) * (val.precioBs - val.precioBs * porc) * 100) / 100
        } else {
          val.subTotal = Math.round(parseInt(val.despachada) * val.precioBs * 100) / 100
        }
        this.actualizarPrecios(val)
        this.$emit('actualizar')
      } else {
        val.subTotal = 0
        this.actualizarPrecios(val)
        this.$emit('actualizar')
      }
    },

    changeDescuento (val) {
      if (val.porcDescuento !== '') {
        if (val.despachada > 0) {
          const porc = (parseInt(val.porcDescuento) / 100)
          val.subTotal = Math.round(parseInt(val.despachada) * (val.precioBs - val.precioBs * porc) * 100) / 100
          this.actualizarPrecios(val)
          this.$emit('actualizar')
        } else {
          val.subTotal = 0
          this.actualizarPrecios(val)
          this.$emit('actualizar')
        }
      } else {
        val.subTotal = 0
        val.porcDescuento = 0
        this.actualizarPrecios(val)
        this.$emit('actualizar')
      }
    },

    save () {
      if (true) {
        const producto = this.idProductosArray.find(data => data.value === this.editedItem.idProducto)
        console.log(producto)
        this.editedItem.idProducto = { 
          nombre: producto.nombre, 
          _id: producto.value, 
          descripcion: producto.descripcion, 
          unidadMedida: producto.unidadMedida
          }
        this.editedItem.stock = producto.cantidad
        this.editedItem.cantidadSolicitada = parseFloat(this.editedItem.despachada)
        this.editedItem.cantidadActual = parseFloat(this.editedItem.despachada)
        // if (this.editedIndex > -1) {
        //   Object.assign(this.prods[this.editedIndex], this.editedItem)
        //   this.$emit('calculos')
        // }
        this.prods.push(this.editedItem)
        this.$emit('actualizar')
        this.close()
      }
    }
  }
}
</script>
